var render, staticRenderFns
import script from "./RenderlessLaravelVuePagination.vue?vue&type=script&lang=js"
export * from "./RenderlessLaravelVuePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9d9befe')) {
      api.createRecord('d9d9befe', component.options)
    } else {
      api.reload('d9d9befe', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/RenderlessLaravelVuePagination.vue"
export default component.exports